<template>
  <div id="addNotes">
    <v-container class="pa-0">
        <v-layout>
            <v-flex class="xs12 sm12 mb-5">
               <v-btn v-if="!session.getSession().adminUser" fab absolute left :to="{ path: '/admin/families'}" class="ml-3 pf-btn-fab">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-btn fab absolute right v-if="textMessage" @click="textMessage = false" class="ml-3 pf-btn-fab">
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
    <v-form v-if="!textMessage" ref="addNotesForm">
        <v-container fluid>
            <v-layout class="button-container pr-4 pl-4">
            <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
              <div class="d-inline-flex">
                <v-btn class="pf-btn pf-btn-cancel" @click="addNotesCancel">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="addNotesUpload">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-select v-model="AddNewNotes.issue"
             outline
              label="Issue"
              :items="IssueList"
              class="pl-3 pr-3"
              @change="isFormDataChanged = true">
              </v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field outline v-model.trim="AddNewNotes.title" label="Add a title" class="pl-3 pr-3 required" :rules="[rules.required]" @input="isFormDataChanged = true"></v-text-field>
              <v-textarea outline v-model.trim="AddNewNotes.note" rows="10" label="Add Notes" class="pl-3 pr-3" @input="isFormDataChanged = true"></v-textarea>
                <upload-btn multiple @file-update="fileSelected($event)" noTitleUpdate :title="title">
                  <template slot="icon">
                      <v-icon right dark>cloud_upload</v-icon>
                  </template>
                  <template slot="text-field"></template>
                </upload-btn>
            </v-flex>
          </v-layout>
          <v-layout class="button-container pr-4 pl-4">
            <v-flex xs12 sm12 md12 class="pr-0 text-xs-right" v-if="isFormDataChanged">
              <div class="d-inline-flex">
                <v-btn class="pf-btn pf-btn-cancel" @click="addNotesCancel">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
                <v-btn class="pf-btn pf-btn-save" @click="addNotesUpload">
                  <v-icon size="16" class="pr-1">check_circle</v-icon>
                  <div>Save</div>
                </v-btn>
              </div>
            </v-flex>
        </v-layout>
        </v-container>
    </v-form>
    <v-container v-else>
        <v-layout wrap>
          <v-flex wrap class="pr-4 ml-4 pf-text-default text-xs-center">
            <p id="message">Your Note added successfully to this Account.</p>
          </v-flex>
        </v-layout>
    </v-container>
  </div>
</template>
<script>

/* global session store moment config */
import Vue from 'vue';
import swal from 'sweetalert2';
import { uploadFile } from '../../helpers/helpers';
import UploadButton from 'vuetify-upload-button';
import { saveAs } from 'file-saver';
import { mapGetters } from 'vuex';

export default {
  name: 'notesAdd',
  components: {
    'upload-btn': UploadButton,
  }, 
  data: vm => ({
    config: config,
    slideModal: false,
    title: 'Select file(s)',
    textMessage: false,
    IssueList: [
      'Yes',
      'No',
    ],
    AddNewNotes: {
      note: '',
      title: '',
      issue: 'No'
    },
    rules: {
      required: value => !!value || 'Title is required.',
    },
    uploadingFile: [],
    accountDataId: '',
    isFormDataChanged: false,
  }),
  computed: {
    ...mapGetters(['Account']),
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    if (!session.getSession().adminUser) {
      this.accountDataId = this.$route.params.item ? this.$route.params.item.id : undefined;
      if (!this.accountDataId) {
        this.addNotesCancel();
      }
    } else {
      this.accountDataId = this.Account.id;
    }
  },
  methods: {
    async addNotesCancel () {
      if (!session.getSession().adminUser) {
        this.$router.push({ path: '/admin/families' });
      } else {
        this.textMessage = true;
        this.isFormDataChanged = false;
        this.$router.push({ path: '/admin/notes' });
      }
    },
    async fileSelected (files) {
      this.isFormDataChanged = true;
      this.uploadingFile = await files;
      this.title = `${this.uploadingFile.length} files selected`;
    },
    async addNotesUpload () {
      if (this.$refs.addNotesForm.validate()) {
        let noteFiles = [];
        this.isFormDataChanged = false;
        let errorHtml = null;
        let files = this.uploadingFile;
        if (files.length !== 0) {
          for (let i = 0; i < files.length; i++) {
            if (files[i] !== 'undefined') {
              this.fileName = files[i].name;
              if (this.fileName.lastIndexOf('.') <= 0) {
                return;
              }
              if (files[i].size > this.config.uploadFileSize) {
                errorHtml = 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB';
              }
              if (errorHtml) {
                swal.fire({
                  title: `<strong>Upload Error</strong>`,
                  type: 'error',
                  html: errorHtml,
                  showCloseButton: true,
                  showCancelButton: false,
                  focusConfirm: false,
                  confirmButtonText: 'Close',
                });
                return;
              }
              window.getApp.$emit('AppProgress', true);
              const fr = new FileReader();
              fr.readAsDataURL(files[i]);
              fr.addEventListener('load', async () => {
                noteFiles.push(files[i]);
                if (i + 1 === files.length) {
                  this.addNoteApiCall(noteFiles);
                }
              });
            } 
          }
        } else {
          let postUrl = `Note/Upload`;
          let extraParams = {
            note: this.AddNewNotes.note,
            title: this.AddNewNotes.title,
            account: this.accountDataId,
            issue: this.AddNewNotes.issue
          };
          let response = await uploadFile(postUrl, null, 'POST', extraParams);
          if (!response.$data) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
          } else {
            swal.fire({
              type: 'success',
              title: 'Note added successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.addNotesCancel();
              }
            });
          }
        }
      }
    },
    async addNoteApiCall (noteFiles) {
      let postUrl = `Note/Upload`;
      let extraParams = {
        note: this.AddNewNotes.note,
        title: this.AddNewNotes.title,
        account: this.accountDataId,
        issue: this.AddNewNotes.issue
      };
      let response = await uploadFile(postUrl, noteFiles, 'POST', extraParams);
      if (!response.$data) {
        window.getApp.$emit('AppProgress', false);
        console.log('error', response.$error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: response.$error
        };
      } else {
        swal.fire({
          type: 'success',
          title: 'File(s) uploaded successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.addNotesCancel();
          }
        });
      }
    },
    isFormDataChange (e) {
      this.isFormDataChanged = true;
    }
  }
};
</script>

<style lang="css" scoped>

#addNotes >>> .primary {
    background-color: #7ac142 !important;
    border-color:#7ac142 !important;
}

#addNotes >>> .v-select .v-text-field__details {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Notes/add.vue